// Auto-detect column indices from detected headers using regex heuristics.
// Pre-fills the mapping form in Step 2 so the user only adjusts unmatched fields.

const PATTERNS = {
  name: /^(nome|name|full.?name|nome.?completo|razao.?social)/i,
  cpf: /^(cpf|document|documento|uniqueid|unique.?id)/i,
  email: /^(e.?mail|email)/i,
  phone: /^(telefone|phone|celular|mobile|tel|fone|whatsapp)/i,
  interest: /^(interesse|interest|produto|product|servico|service|assunto)/i,
};

export default function autoMap(headers) {
  const normalized = (headers || []).map(h => String(h || '').trim());

  const firstMatchIndex = (pattern) => {
    const idx = normalized.findIndex(h => pattern.test(h));
    return idx === -1 ? null : idx;
  };

  const allMatchIndexes = (pattern) => {
    return normalized.reduce((acc, h, idx) => {
      if (pattern.test(h)) acc.push(idx);
      return acc;
    }, []);
  };

  return {
    name: firstMatchIndex(PATTERNS.name),
    cpf: firstMatchIndex(PATTERNS.cpf),
    email: firstMatchIndex(PATTERNS.email),
    phone: firstMatchIndex(PATTERNS.phone),
    interest: allMatchIndexes(PATTERNS.interest),
  };
}
